import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

const useIdentityStore = defineStore('identity', () => {
  const fileNumber = ref<string>('');
  /** Indication qu'une première validation backend a été effectuée pour vérifier la présence d'une session ouverte.
   * NOTE: L'indice permet uniquement de déterminer s'il faut attendre après une validation en cours (ou non),
   * et non de valider si l'utilisateur est connecté.
   */
  const accountValidationDone = ref<boolean>(false);

  const isSignedIn = computed<boolean>(() => accountValidationDone.value && !!fileNumber.value);

  function signIn(newFileNumber: string) {
    // La validation devrait déjà être complétée en principe, c'est davantage par protection qu'on force le statut
    // lors de la connexion du compte.
    setAccountValidationDone(true);
    fileNumber.value = newFileNumber;
  }

  function signOut() {
    // La validation du compte reste à "true" vu qu'une déconnexion effectue un appel backend:  On sait alors
    // l'état de connexion de l'utilisateur, il est déconnecté!
    setAccountValidationDone(true);
    fileNumber.value = '';
  }

  function setAccountValidationDone(completed: boolean) {
    accountValidationDone.value = completed;
  }

  return {
    fileNumber,
    accountValidationDone,
    setAccountValidationDone,
    signIn,
    signOut,
    isSignedIn,
  };
});

export default useIdentityStore;
